// SosToolkitCard — Phase 8 replacement for the global SosToolkitButton
// FAB that used to live in AppShell. The toolkit modal itself is
// unchanged; this card just opens it from inside Today.
//
// Visibility rules:
//  - Shown by default for all users.
//  - Hidden when me.settings.sosCardHidden === true (toggled from
//    Settings → Help & appearance → "Show SOS toolkit on Today").
//
// The card is intentionally smaller than the primary "Log dose" surface
// and sits next to TalkMeDownCard — the two are sibling crisis affordances
// (TalkMeDown for "I want to talk it through with AI", SosToolkit for
// "I need a physical-coping step right now"). Together they keep two
// distinct one-tap escape hatches visible above the fold.

import { useState } from 'react';
import { LifeBuoy } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Icon } from '../ui/Icon';
import { SosToolkit } from '../domain/SosToolkit';

export function SosToolkitCard() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Card>
        <div className="row" style={{ gap: 'var(--space-3)' }}>
          <span
            className="crisis-action-icon"
            style={{ background: 'var(--color-accent-soft)', color: 'var(--color-accent)' }}
          >
            <Icon icon={LifeBuoy} />
          </span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600 }}>SOS toolkit</div>
            <div className="muted text-caption">
              Quick coping for an urge — breathing, grounding, body-first tips.
            </div>
          </div>
          <Button variant="accent" onClick={() => setOpen(true)}>
            Open
          </Button>
        </div>
      </Card>
      <SosToolkit open={open} onOpenChange={setOpen} />
    </>
  );
}
